
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Grid extends Vue {
    @Prop() readonly length!: number;
    @Prop({ type: Number, default: 48 }) readonly rowHeight!: number;
}
